import type { HttpClient } from "../client/types";
import { getApi } from "../client/apiClient";
import type { SwimmerType } from "../client/types/swimmer-type.types";

const createSwimmerTypeEndpoints = (client: HttpClient = getApi()) => ({
  getSwimmerTypes: async (): Promise<SwimmerType[]> => {
    const { data } = await client.get<SwimmerType[]>(
      "/swimmer-types"
    );
    return data;
  },
  getSwimmerTypeById: async (id: number): Promise<SwimmerType> => {
    const { data } = await client.get<SwimmerType>(
      `/swimmer-types/${id}`
    );
    return data;
  },
});

export type SwimmerTypeEndpoints = ReturnType<
  typeof createSwimmerTypeEndpoints
>;

export const swimmerTypeEndpoints = createSwimmerTypeEndpoints();
